"use client";

import React, { useState, useRef, useEffect } from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function TheWorldAtYourFingertips() {
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const sectionRef = useRef<HTMLElement>(null);
  const handleMouseMove = (e: React.MouseEvent<HTMLElement>) => {
    if (!sectionRef.current) return;
    const {
      clientX,
      clientY
    } = e;
    const {
      innerWidth,
      innerHeight
    } = window;
    const moveX = (clientX / innerWidth - 0.5) * 50;
    const moveY = (clientY / innerHeight - 0.5) * 50;
    setMousePosition({
      x: moveX,
      y: moveY
    });
  };
  return <section data-section-id="245355" id="cinematic-vision" ref={sectionRef} onMouseMove={handleMouseMove} className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0 scale-110 transition-transform duration-1000 ease-out will-change-transform" style={{
      transform: `translate3d(${mousePosition.x}px, ${mousePosition.y}px, 0) scale(1.1)`
    }}>
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658650/img/pivotal_production_hero_loop.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658650/img/pivotal_production_hero_loop.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658650/img/pivotal_production_hero_loop.png-wvc-sizes" alt="Cinematic video production reel background" className="w-full h-full object-cover opacity-50" loading="lazy" decoding="async" />
        
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-background/20 via-background/60 to-background" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--color-background)_100%)] opacity-90" />
      </div>

      {}
      <div className="relative z-10 flex flex-col items-center justify-center text-center px-4 sm:px-6 lg:px-8 w-full max-w-7xl mx-auto">
        
        {}
        <h1 className="font-default text-5xl sm:text-7xl md:text-8xl lg:text-[9rem] font-bold tracking-tighter text-foreground mb-16 leading-none uppercase" style={{
        textShadow: `
              0 0 20px rgba(0, 0, 0, 0.5),
              0 0 40px var(--color-primary),
              0 0 80px var(--color-primary)
            `
      }}>
          Pivotal Production
        </h1>

        {}
        <div className="relative group flex items-center justify-center mt-8">
          {}
          <div className="absolute inset-0 rounded-none bg-primary/20 animate-ping opacity-75 duration-1000" />
          
          {}
          <div className="absolute -inset-4 rounded-none bg-primary/5 blur-2xl group-hover:bg-primary/15 transition-colors duration-500" />
          
          <Button variant="outline" size="icon" className="relative h-24 w-24 sm:h-32 sm:w-32 rounded-none bg-transparent backdrop-blur-sm border-primary/40 hover:bg-primary hover:scale-105 hover:border-primary transition-all duration-500 text-foreground hover:text-primary-foreground shadow-none" aria-label="Play immersive tour video">
            <Play className="w-10 h-10 sm:w-14 sm:h-14 ml-2 sm:ml-3 fill-foreground/80 group-hover:fill-primary-foreground transition-all duration-300" />
          </Button>
        </div>
        
      </div>
    </section>;
}